import React, { useMemo } from 'react';
import { ChallengeDriverItem } from "../../../../types/gamification";
import Columns from './Columns';
import Row from './Row';
import { TableRowLoading } from '@components';


interface CustomTableProps {
  trips: ChallengeDriverItem[];
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (key: string) => void;
  searchValue: string;
  onSearchChange: (v: string) => void;
  isLoading: boolean;
}

interface Column {
  key: string;
  label: string;
  sortable?: boolean;
  width?: string;
}

const COLUMNS = [
  { key: 'driverName', label: 'Motorista' },
  { key: 'challegeName', label: 'Desafio' },
  { key: 'routeName', label: 'Tipo' },
  { key: 'destination', label: 'Destino' },
  { key: 'tripDate', label: 'Data' },
  { key: 'vwcoin', label: 'Pontos' },
] as const;

const EmptyState = () => (
  <tr>
    <td colSpan={COLUMNS.length} className="text-center padding-y-24">
      Nenhum resultado
    </td>
  </tr>
);

const CustomTable: React.FC<CustomTableProps> = ({
  trips,
  sortBy,
  sortDir,
  onSort,
  isLoading,
}) => {
  const renderRows = useMemo(() => (
    trips.map((trip, idx) => <Row key={`${trip.driverId}-${idx}`} trip={trip} />)
  ), [trips]);

  return (
    <div className="margin-top-16">
      <table className="table table-layout-fixed table-bordered table-head-filled bg-white width-100pct">
        <thead>
          <Columns
            columns={[...COLUMNS]}
            sortBy={sortBy}
            sortDir={sortDir}
            onSort={onSort}
          />
        </thead>
        <tbody>
          {isLoading ? (
            <TableRowLoading cols={6} rows={10} />
          ): null}

          {!isLoading && trips.length === 0 ? <EmptyState /> : renderRows}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(CustomTable);